<template>
    <div class="cart_resume__header section">
        <div class="description">{{ copydeck.cart.txt_description[ lang ] }}</div>
        <div class="mobile-flex">
            <div class="quantity">{{ copydeck.cart.txt_quantity[ lang ] }}</div>
            <div class="price">{{ copydeck.cart.txt_price[ lang ] }}</div>
        </div>
    </div>
    <!-- div.cart_resume__header -->

    <div class="cart_resume__content section"
         v-for="(order, index) in sortedOrders"
         :key="`product-${order.id}`">

        <div class="description">
            <span class="mobile-title">{{ copydeck.cart.txt_description[lang] }}</span>
            <div class="group">
                <strong>{{ order.isDeliveryByMail ? '' : copydeck.page_order.title_gift_card[lang] }}</strong>
                <span class="item"> {{ getProductById (order.id_product, "name") }}</span>
            </div>
        </div>
        <div class="mobile-flex">
            <div class="quantity" v-if="order.isDeliveryByMail">
                <!--            <span class="mobile-title">{{ copydeck.cart.txt_quantity[lang] }}</span> {{ order.quantity }}-->

                <order-counter :value="order.quantity"
                               :max=" 1"
                               :min=" 0 "
                               :group-index="0"
                               :modifiable="false"
                               :product="getProduct(order)"
                               @change="onOrderChange" />

            </div>
            <div class="quantity" v-else-if="!order.customGiftCard">
                <!--            <span class="mobile-title">{{ copydeck.cart.txt_quantity[lang] }}</span> {{ order.quantity }}-->

                <order-counter :value="order.quantity"
                               :max=" order.id_product === 2 ? 999 : 9"
                               :min=" order.id_product === 2 ? 25 : 0 "
                               :group-index="0"
                               :modifiable="true"
                               :product="getProduct(order)"
                               @change="onOrderChange" />

            </div>
            <div class="quantity" v-else>
                <order-removal :value="order.quantity"
                               :max=" order.id_product === 2 ? 999 : 9"
                               :min=" order.id_product === 2 ? 25 : 0 "
                               :group-index="0"
                               :modifiable="true"
                               :product="getProduct(order)"
                               @change="onOrderChange" />


            </div>
            <div class="price">
                <span class="mobile-title">{{ copydeck.cart.txt_price[lang] }}</span> {{ getOrderPrice (order, orders)}}&nbsp;$
            </div>

        </div>
    </div>
    <!-- div.cart_resume__content -->

</template>

<script>
export default {
    name: "CartRecap",
    components: {ProductCounter},
}
</script>

<script setup>

import { computed } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";
import ProductCounter from "../components/ProductCounter.vue";
import OrderCounter from "./OrderCounter.vue";
import OrderRemoval from "./OrderRemoval.vue";
import { dispatchWindowEvent } from '../composables/utils';

let store = useMainStore();
let { copydeck, onlyProducts,  lang, orders, sortedOrders, orderCount  } = storeToRefs(store);

let { getProductById, getOrderPrice,  } = store;


function getProduct (order)
{
    // console.log("getProduct");
    // console.log("onlyProducts", onlyProducts);
    // console.log("order", order);

    const id_product = order.id_product;
    const product = onlyProducts.value.find( p => p.id === id_product);

    return product;
}

function got (row, path, lang)
{
    if (!row[path])
        return false;

    let v;

    if (lang !== undefined)
    {
        v = row[path][lang];
    }
    else
    {
        v = row[path];
    }


    return v && v !== "";
}

function getOrder (product)
{
    let id_product = product.id;

    let productOrder = sortedOrders.value.find( o => o.id_product === id_product);

    if (!productOrder)
        return 0;

    let quantity = productOrder.quantity;

    return quantity;
}



function onOrderChange (id, details, groupIndex = -1)
{
    //let productOrderIndex = orders.value.findIndex( o => o.id_product === id);
    let productOrderIndex = orders.value.findIndex( o => o.id_product === id);

    if (productOrderIndex === -1)
    {
        //orders.value.push( Object.assign({ id_product: id }, details));
        orders.value.push( Object.assign({ id_product: id }, details));
    }
    else
    {
        //let po = orders.value[productOrderIndex];
        let po = orders.value[productOrderIndex];
        po = Object.assign(po, details);

        //orders.value[productOrderIndex] = po;
        if (po.customGiftCard && po.quantity === 0)
        {
            orders.value.splice(productOrderIndex, 1);
        }
        else
        {
            orders.value[productOrderIndex] = po;
        }
    }


    dispatchWindowEvent('la-source-cart-changed', { numItems : orderCount.value })
}


</script>

